import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ContasService from '../../../../services/prest-contas-auth';



const Contas = () => {
    const [categoria, setCategoria] = useState("");
    const [referencia, setReferencia] = useState("");
    const [ano, setAno] = useState("");
    const [anexoTipo, setAnexoTipo] = useState(false);
    const [anexos, setAnexos] = useState([]);
    const [link, setLink] = useState([]);
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const montaForm = async () => {
        const lic = new FormData();
        lic.append("categoria", categoria)
        lic.append("referencia", referencia)
        lic.append("ano", ano)
        lic.append("link", link)
        for (let i = 0; i < anexos.length; i++) {
            lic.append('anexos', anexos[i]);
        }
        return lic
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lic = await ContasService.cadastro(dados)
            if (lic.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                alert(lic.data["error"])
            }
        } catch (error) {
            alert(error)
        }
    }


    const handleUploadDocumentos = (event) => {
        const files = event.target.files;
        setAnexos(files);
    };


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setCategoria("");
        setReferencia("");
        setAno("");
        setAnexos([]);
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Ata da Audiência Pública de Apresentação de Metas Fiscais">Ata da Audiência Pública</option>
                                        <option value="Prestação de Contas Anual">Prestação de Contas Anual</option>
                                        <option value="Parecer do TCE-RJ sobre a Prestação de Contas Anual">Parecer do TCE-RJ sobre a Prestação de Contas Anual</option>
                                        <option value="Decretos do Legislativo">Decretos do Legislativo</option>
                                        <option value="Convites de Audiências Públicas">Convites de Audiências Públicas</option>
                                        <option value="Renúncia de Receita">Renúncia de Receita</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="Referência">
                                <FloatingLabel
                                    label="Referência"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="Referência"
                                        name="referencia"
                                        onChange={e => setReferencia(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="1º Quadrimestre">1º Quadrimestre</option>
                                        <option value="2º Quadrimestre">2º Quadrimestre</option>
                                        <option value="3º Quadrimestre">3º Quadrimestre</option>
                                        <option value="Parte 1">Parte 1</option>
                                        <option value="Parte 2">Parte 2</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={12}>
                            <Form.Group className="mb-3" controlId="anexoTipo">
                                <Form.Label>Tipo de Anexo</Form.Label>
                                <Form.Select
                                    required
                                    name="anexoTipo"
                                    onChange={e => setAnexoTipo(e.target.value)}
                                >
                                    <option>Nenhum</option>
                                    <option value="link">Link</option>
                                    <option value="documento">Documento</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {anexoTipo ?
                            <Col lg={12}>
                                <Form.Group className="mb-3" controlId="anexo">
                                    <Form.Label>{anexoTipo === "link" ? "Link" : "Documento"}</Form.Label>
                                    {anexoTipo === "link" ? (
                                        <Form.Control
                                            type="text"
                                            name="link"
                                            value={link}
                                            onChange={e => setLink(e.target.value)}
                                        />
                                    ) : (
                                        <Fragment>
                                            <Form.Control
                                                type="file"
                                                name="anexos"
                                                onChange={handleUploadDocumentos}
                                                accept=".pdf, .xlsx, .xls"
                                                multiple // Permite múltiplos arquivos
                                            />
                                        </Fragment>
                                    )}
                                </Form.Group>
                            </Col> : ''}
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/contas'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Documento cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/contas/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Documentos
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/contas'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Contas;